import { useElements } from '../../elements';
import { applyTemporaryStyles, useIsOverflowing } from '../../utils';

// Layout thrashing намеренный:
// Для корректного замера переполнения нужно временно изменить flex-стили.
// Это вызывает forced reflow, но в нашем случае количество элементов и частота измерений минимальны,
// так что это приемлемый компромисс ради точного результата.
export const useIsBarOverflowing = () => {
  const { buttons } = useElements();
  const withMultipleButtons = buttons.length > 1;

  const {
    ref: wrapperRef,
    isOverflowing: isOverflowingWrapper,
    revalidate: revalidateWrapper
  } = useIsOverflowing({
    checkIfOverflowing: (node) => {
      const restoreStyles = applyTemporaryStyles(node, {
        flexDirection: 'row',
        minWidth: '0',
        overflow: 'hidden'
      });

      const isOverflowing = node.scrollWidth > node.clientWidth;
      restoreStyles();

      return withMultipleButtons
        ? isOverflowingContainer && isOverflowing
        : isOverflowing;
    },
    enabled: false
  });

  const { ref: containerRef, isOverflowing: isOverflowingContainer } =
    useIsOverflowing({
      checkIfOverflowing: (node) => {
        if (withMultipleButtons) {
          revalidateWrapper();
        }

        const restoreStyles = applyTemporaryStyles(node, {
          flexDirection: 'row'
        });

        if (!withMultipleButtons) {
          revalidateWrapper();
        }

        const isOverflowing = node.scrollWidth > node.clientWidth;
        restoreStyles();

        return withMultipleButtons
          ? isOverflowing
          : isOverflowingWrapper && isOverflowing;
      }
    });

  return {
    wrapperRef,
    isOverflowingWrapper,
    containerRef,
    isOverflowingContainer
  };
};
